module.exports = __webpack_public_path__ + "img/stack-inserter.1d996fa5.png";